<template>
	<div class="list list--locations list-locations">
		<table-list
			:items="locations"
			:loading="isLoading"
		>
			<template slot="header">
				<span
					:class="`locations-header-item locations-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					<component :is="orderBy[key] ? 'a' : 'span'" @click="sort(key)"> {{ col }}</component>
					<ion-icon :name="query.order == 'asc' ? `caret-up` : `caret-down`" v-if="orderBy[key] && orderBy[key] == query.orderBy"></ion-icon>
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<router-link
					:class="`locations-item locations-item--${key} locations-item--${item['status']}`"
					:key="`item_${key}`"
					:to="{ name: 'location', params: { locationId: item.locationId } }"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</router-link>
			</template>

		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'

import TableList from '@/components/TableList'
import { LocationStatus } from '@/lib/enums'

export default {
	name: 'ListLocations',
	components: {
		TableList,
	},
	props: {
		clients: {
			type: Array,
			default: () =>([]),
		},
		locations: {
			type: Array,
			default: () => ([]),
		},
		noClient: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		order: 'asc',
	}),
	computed: {
		isLoading() {
			return this.$store.getters['misc/loading']
		},
		query() {
			return this.$route.query
		},
		orderBy() {
			let orderBy = {
				// nameEmail: 'firstName',
				// dateCreated: 'dateCreated',
				// organization: 'organization.name',
				// 'settings.salesforceId': 'salesforceId',
				// dateLogin: 'dateLogin',
				// status: 'status',
			}

			return orderBy
		},
		columns() {
			let columns = {
				'client.name': 'Client',
				name: 'Name',
				address: 'Address',
				city: 'City',
				state: 'State',
				status: 'Status',
			}

			if (this.noClient)
				delete columns['client.name']

			return columns
		},
	},
	methods: {
		transform(key, value) {
			switch(key) {
				case 'dateCreated':
					try {
						value = `${format(parseISO(value), 'PPp')}`
					} catch (error) {
						console.warn(error)
					}
					return value
				case 'dateLogin':
					if (!value) return '(no login yet)'
					try {
						const dt = parseISO(value)
						value = `<span title="${format(dt, 'Pp')}">${formatDistanceToNowStrict(dt, { addSuffix: true})}</span>`
					} catch (error) {
						console.warn(error)
					}
					return value
				case 'status':
					return LocationStatus.match(value)
				case 'clientId':
					const client = this.clients.find(c => c.clientId == value)
					return client ? client.name : ``
			}
			return value
		},
		sort(key) {

		},
		get,
	}
}
</script>

<style scoped lang="scss">
.list-locations {
	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('border', 'light');
			display: grid;
			grid-template-columns: minmax(100px, 1.25fr) minmax(100px, 1.25fr) repeat(auto-fit, minmax(60px, 1fr));

			@include modules.media-query('phone') {
				grid-template-columns: minmax(50%, 1fr) minmax(50%, 1fr);
			}
		}

		.list-locations__app-list {
			list-style-type: none;
			margin: 0;
			padding: 0;
		}
	}

	.locations-header-item {
		@include modules.fontSize(14px);
		align-items: center;
		display: flex;
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.locations-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		overflow-wrap: break-word;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}

		&--pending {
			&.locations-item--status {
				color: modules.color_('alert', 'warn');
			}
		}

		&--removed {
			opacity: 0.7;

			&.locations-item--status {
				color: modules.color_('alert', 'error')
			}
		}
	}
}
</style>
